<template>
  <mHeader />
  <mHomeBaner />
  <mHomeTabNews :data="state.tabNews" />
  <mHomeSectionNews :data="state.sectionNews" />
</template>

<script>
import { reactive } from 'vue'
import { getHomeTabNews, getHomeSectionNews } from '@/api/article'
import { toast } from '@/utils/ui'
export default {
  setup (props) {
    const state = reactive({
      tabNews: [],
      sectionNews: []
    })
    const getData = async () => {
      toast.loading()
      state.tabNews = await getHomeTabNews()
      state.sectionNews = await getHomeSectionNews()
      toast.close()
    }
    getData()

    return {
      state
    }
  }
}
</script>
